export default "__VITE_PUBLIC_ASSET__378514d9__"